import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AllVendorsList from "../components/AllVendorsList";

const VendorsListPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='All Vendors ' />

                <AllVendorsList />

            </MasterLayout>
        </>
    );
};

export default VendorsListPage;
